import { OktaAuth } from '@okta/okta-auth-js';
import axios from 'axios';

// Helper to get env from container or process.env
const getEnv = (key: string): string | undefined => {
    return (window as any).__CONTAINER_ENV__?.[key] ?? process.env[key]
}

export class SizeService {

    private oktaAuth: OktaAuth;
    private host: string;

    constructor(oktaAuth: OktaAuth) {
        this.oktaAuth = oktaAuth;
        this.host = (window as any).env !== undefined ? (window as any).env.REACT_APP_PRODUCT_WEIGHTS_HOST : getEnv('REACT_APP_PRODUCT_WEIGHTS_HOST');
    }

    async getSizesByProductCode(productCode: string): Promise<any> {
        const accessToken = await this.oktaAuth.getAccessToken();
        
        return await axios.get(
            `${this.host}/api/weight/${productCode}`,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
    }

    async storeProductSize(produceSize: any): Promise<any> {
        const accessToken = await this.oktaAuth.getAccessToken();
        
        return await axios.post(
            `${this.host}/api/weight/correction`,
            produceSize,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
    }

}


